import actionTypes from '../../actions/dictionaries/dictionaries.action-types';

export default (state = {}, action) => {
  switch (action.type) {
    case actionTypes.FETCH_ACTIVITY_EVENTS_DICTIONARY_SUCCESS:
      return { ...action.activityEvents };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/app/reducers/dictionaries/activity-events-dictionary.js